import Layout from '../../layout';
import Divider from '../../components/Divider';
import Services from '../../components/Services';
import Partners from '../../components/Partners';
import Customers from '../../components/Customers';
import Translator from '../../components/Translator';

// import banner from '../../assets/industria-4-0-o-que-e-conceitos.jpg';
import banner from '../../assets/banner.jpg';

import { Banner, Title, AboutUsContainer, TitleBorderBottomContainer, TitleBorderBottom, Paragraph } from './style';

export default function Home() {
  return (
    <Layout>
      <Banner id="home" src={banner} />

      <Title>
        <h2>
          <Translator path={'who_we_are.title'} />
        </h2>
      </Title>

      <TitleBorderBottomContainer>
        <TitleBorderBottom />
      </TitleBorderBottomContainer>

      <AboutUsContainer>
        <Paragraph>
          <Translator path={'who_we_are.text'} />
        </Paragraph>
      </AboutUsContainer>

      <Divider />

      <Services />

      <Divider />

      <Customers />

      <Divider />

      <Partners />
    </Layout>
  );
}
